import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  GET_PROFILE_REQUEST,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAILURE
} from '../types/authTypes';

const getInitialState = () => {
  const token = localStorage.getItem('access_token');
  const user = localStorage.getItem('user');
  return {
    user: user ? JSON.parse(user) : null,
    token: token || null,
    token_type: localStorage.getItem('token_type') || null,
    expires_in: localStorage.getItem('expires_in') || null,
    isAuthenticated: !!token,
    loading: false,
    error: null
  };
};

const authReducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
    case GET_PROFILE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        user: action.payload.user,
        token: action.payload.access_token,
        token_type: action.payload.token_type,
        expires_in: action.payload.expires_in,
        isAuthenticated: true,
        loading: false,
        error: null
      };
    case GET_PROFILE_SUCCESS:
      return {
        ...state,
        user: action.payload,
        loading: false,
        error: null
      };
    case LOGIN_FAILURE:
    case GET_PROFILE_FAILURE:
      return {
        ...state,
        user: null,
        token: null,
        token_type: null,
        expires_in: null,
        isAuthenticated: false,
        loading: false,
        error: action.payload
      };
    case LOGOUT:
      return {
        ...state,
        user: null,
        token: null,
        token_type: null,
        expires_in: null,
        isAuthenticated: false,
        loading: false,
        error: null
      };
    default:
      return state;
  }
};

export default authReducer; 